import React, {useState} from 'react';
import {Card, CardContent, withStyles} from "@material-ui/core";
import SnackbarContent from "@material-ui/core/SnackbarContent";

import i18n from '../i18n';
import Layout from '../components/Layout';
import Toolbar from "../components/Toolbar/Toolbar";
import Grid from "@material-ui/core/Grid/Grid";
import Table from "@material-ui/core/Table/Table";
import Typography from "@material-ui/core/Typography/Typography";
import EllipsisWithTooltip from "../components/Formater/EllipsisWithTooltip";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import {IntlProvider, FormattedDate} from "react-intl";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Icon from "@material-ui/core/Icon/Icon";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import MediaSearchField from "../components/Media/SearchField";
import ProtocolPrintSection from "../components/Dashboard/ProtocolPrintSection";
import axios from "axios";

const Dashboard = ({appointmentList, role, classes, session}) => {

    const [appointments, setappointments] = useState(appointmentList);
    const CancelToken = axios.CancelToken;
    let cancel;

    const doSearch = (searchString) => {
        cancel && cancel();

        axios.get('/search-appointment', {params: {'query': searchString}, cancelToken: new CancelToken(function executor(c) {cancel = c;})}).then((response) => {
            if (response.data && response.data.length > 0) {
                setappointments(response.data.map(item => item.entity));
            } else {
                setappointments([]);
            }
        })
    }
    return (
    <Layout>
        <Toolbar
            // disableGutters
            // title={i18n.get('dashboard.title')}
            title={''}
        />

        <div className={classes.flash}>
            {session.status && (
                <SnackbarContent
                    className={classes.message}
                    aria-describedby="client-snackbar"
                    message={(
                        <span id="client-snackbar">
                            {session.status}
                        </span>
                    )}
                />
            )}
        </div>

        <Grid container spacing={16}>
            {(role === 'admin' || role === 'accountant') &&
            <ProtocolPrintSection/>
            }

            {role != 'technician' &&
            <Grid item xs={12}>
                <Card>
                    <CardContent>
                        <Grid container spacing={8}>
                            <Grid item xs={12}>
                                <Typography>
                                    {i18n.get('appointments.appointments')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <MediaSearchField
                                    searchByTyping={true}
                                    doSearch={doSearch}
                                    label={i18n.get('default.search_appointment')}
                                />
                            </Grid>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Name</TableCell>
                                        <TableCell>Kunde</TableCell>
                                        <TableCell>Techniker</TableCell>
                                        <TableCell>Maschine</TableCell>
                                        <TableCell>nächste Prüfung</TableCell>
                                        <TableCell>&nbsp;</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {appointments.map(appointment => {
                                        return (
                                            <TableRow key={appointment.id}>
                                                <TableCell>
                                                    <Typography component='div'>
                                                        <EllipsisWithTooltip>
                                                            {appointment.appointment_name}
                                                        </EllipsisWithTooltip>
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography component='div'>
                                                        <EllipsisWithTooltip>
                                                            {appointment.customer.customer_name}
                                                        </EllipsisWithTooltip>
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography component='div'>
                                                        <EllipsisWithTooltip>
                                                            {appointment.technician.name}
                                                        </EllipsisWithTooltip>
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography component='div'>
                                                        <EllipsisWithTooltip>
                                                            {appointment.machine.name}
                                                        </EllipsisWithTooltip>
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography component='div'>
                                                        <FormattedDate value={appointment.day_next_appointment}/>
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Tooltip placement="bottom-end"
                                                             title={i18n.get('dashboard.visit_appointment')}
                                                             classes={{tooltip: classes.popper}}>
                                                        <IconButton href={`/appointments/${appointment.id}`}
                                                                    className={classes.iconButton}>
                                                            <Icon className={classes.iconButtonIcon}>search</Icon>
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip placement="bottom-end"
                                                             title={i18n.get('dashboard.create_protocol')}
                                                             classes={{tooltip: classes.popper}}>
                                                        <IconButton
                                                            href={`/protocols/create/customer/${appointment.customer.id}/appointment/${appointment.id}/structure/${appointment.machine.structure.id}`}
                                                            className={classes.iconButton}>
                                                            <Icon className={classes.iconButtonIcon}>assignment</Icon>
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
            }

            {role === 'technician' &&
            <Grid item xs={12} spacing={8}>
                <Card>
                    <CardContent>
                        <Grid container spacing={24}>
                            <Grid item xs={12}>
                                <Typography>
                                    {i18n.get('appointments.appointments')}
                                </Typography>
                            </Grid>
                            {appointments.map((dayAppointments) => {
                                return (
                                    <Grid item xs={12}>
                                        <Paper className={classes.px_16}>
                                            <Grid container spacing={8}>
                                                <Grid item xs={12}>
                                                    <Typography component='div'>
                                                        <EllipsisWithTooltip>
                                                            <FormattedDate
                                                                value={new Date(dayAppointments[0].day_next_appointment)}
                                                                format=""/>
                                                        </EllipsisWithTooltip>
                                                    </Typography>
                                                </Grid>
                                                {dayAppointments.map((appointment) => {
                                                    return (
                                                        <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                                                            <Card>
                                                                <CardContent>
                                                                    <Grid container spacing={8}>
                                                                        <Grid item xs={12} sm={6}>
                                                                            <Grid container spacing={8}>
                                                                                <Grid item xs={12}>
                                                                                    <Typography component='div'>
                                                                                        <EllipsisWithTooltip>
                                                                                            {appointment.appointment_name}
                                                                                        </EllipsisWithTooltip>
                                                                                    </Typography>
                                                                                </Grid>
                                                                                <Grid item xs={12}>
                                                                                    <Typography component='div'>
                                                                                        <EllipsisWithTooltip>
                                                                                            {appointment.customer.customer_name}
                                                                                        </EllipsisWithTooltip>
                                                                                    </Typography>
                                                                                </Grid>
                                                                                <Grid item xs={12}>
                                                                                    <Typography component='div'>
                                                                                        <EllipsisWithTooltip>
                                                                                            {appointment.technician.name}
                                                                                        </EllipsisWithTooltip>
                                                                                    </Typography>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Grid>
                                                                        <Grid item xs={12} sm={6}>
                                                                            <Grid container spacing={8}>
                                                                                <Grid item xs={12}>
                                                                                    <Button
                                                                                        href={`/appointments/${appointment.id}`}
                                                                                        variant="contained"
                                                                                        className={classes.button}>
                                                                                        {i18n.get('dashboard.visit_appointment')}
                                                                                    </Button>
                                                                                </Grid>
                                                                                <Grid item xs={12}>
                                                                                    <Button
                                                                                        href={`/protocols/create/customer/${appointment.customer.id}/appointment/${appointment.id}/structure/${appointment.machine.structure.id}`}
                                                                                        variant="contained"
                                                                                        className={classes.button}>
                                                                                        {i18n.get('dashboard.create_protocol')}
                                                                                    </Button>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                </CardContent>
                                                            </Card>
                                                        </Grid>
                                                    );
                                                })}
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
            }
        </Grid>

    </Layout>
    )
};


const styles = theme => ({
    flash: {
        marginBottom: theme.spacing.unit * 3,
    },
    message: {
        maxWidth: '100%',
        backgroundColor: theme.palette.primary.main,
    },
    iconButton: {
        fontSize: 12,
        padding: '8px',
        opacity: 0.5,

        '&:hover': {
            color: theme.colors.primary,
            opacity: 1
        }
    },
    button: {
        fontSize: 12,
        padding: '8px',
        opacity: 0.5,
        backgroundColor: '#e5f0ff',
        width: '100%',

        '&:hover': {
            backgroundColor: '#e5f0ff',
            color: '#003c58',
            opacity: 1
        }
    },
    iconButtonIcon: {
        fontSize: 20
    },
    px_16: {
        padding: '16px',
    },
});

export default withStyles(styles)(Dashboard);



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Dashboard.jsx